export const resources = {
  en: {
    common: {},
  },
};

export default resources;
